import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Suggestions } from 'src/app/services/static-assets';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-face-error',
  templateUrl: './face-error.component.html',
  styleUrls: ['./face-error.component.scss']
})
export class FaceErrorComponent {

  @Input() error: Suggestions;
  @Output() retryEmitter = new EventEmitter<void>();
  staticAssetsUrl = environment.staticScripts.staticAssets;

  retry(): void {
    this.retryEmitter.emit();
  }

}
